module.exports = __webpack_public_path__ + "static/media/apartly.81731096.jpg";